import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import './PlaylistReviewMode.styl';
import throttle from 'lodash/throttle';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import UpcomingReviewsActions from 'actions/coaching/UpcomingReviewsActions';
import Button from '@material-ui/core/Button';
import CoachingReviewTypeStore from 'stores/coaching/CoachingReviewTypeStore';
import {List} from 'immutable';
import CoachingReviewStore from 'stores/coaching/CoachingReviewStore';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import {navigateToCallsTab} from 'utils/navigateToCallsTab';
import FileUploadScorecardStore from 'stores/scorecards/FileUploadScorecardStore';
import {START_LABEL_COACH} from 'components/coaching/SubmitReviewFeedback';
import {ensureReviewMetadata} from 'components/StatsPage2.utils';
import UPCOMING_REVIEW_ROLES from 'actions/coaching/UPCOMING_REVIEW_ROLES';

@connectToStores
export default class PlaylistReviewMode extends React.Component {
  static getStores() {
    return [CoachingReviewTypeStore, CoachingReviewStore, FileUploadScorecardStore];
  }

  static getPropsFromStores(props) {
    const reviewTypes = CoachingReviewTypeStore.getState().types;
    const reviewStore = CoachingReviewStore.getState();

    const reviewFileUploads = reviewStore.reviewFileUploads.get(props.review.id, List());

    const reviewType =
      props.review.reviewTypeId && reviewTypes
        ? reviewTypes.get(props.review.reviewTypeId)
        : undefined;

    return {
      reviewType: reviewType,
      reviewFileUploads,
    };
  }

  componentDidMount() {
    setTimeout(() => ensureReviewMetadata(), 0);
  }

  render() {
    const {review, sessionUser, reviewType, reviewFileUploads, plan} = this.props;

    const isCoach = sessionUser.id === review.coachUserId;

    const livecoachLabel =
      review.livecoachingStubs > 0 ? 'Coach Another Call Live' : 'Coach a Call Live';

    const addLabel =
      reviewFileUploads && reviewFileUploads.size > 0 ? 'Add Another Call' : 'Add Calls';

    const noCallsAllowed = reviewType && !reviewType.includesCalls;
    const callsAllowed = !noCallsAllowed;

    const finalCoachSentence = callsAllowed
      ? `Optionally, click the buttons below to
    add more calls, or "${START_LABEL_COACH}" to begin.`
      : `Click "${START_LABEL_COACH}" to begin.`;

    const finalRepSentence = callsAllowed
      ? `Optionally, click the button below to add more calls.`
      : ``;

    return (
      <div className="playlist-review-mode playlist-content">
        {callsAllowed && (
          <div className="pod">
            {isCoach && (
              <p>
                You're currently previewing your meeting with {plan.recipient.info.getFullName()}.{' '}
                {finalCoachSentence}
              </p>
            )}
            {!isCoach && (
              <p>
                You're currently previewing your meeting with {plan.coach.info.getFullName()}.{' '}
                {finalRepSentence}
              </p>
            )}
            <div className="review-mode-ctas">
              {isCoach && callsAllowed && (
                <Button
                  variant="outlined"
                  fullWidth
                  className="ev-button"
                  onClick={throttle(
                    () =>
                      CoachingReviewActions.setLiveCoachingStubs(
                        review.id,
                        review.livecoachingStubs + 1
                      ).then(() =>
                        UpcomingReviewsActions.upcomingReviews(
                          sessionUser.id,
                          isCoach ? UPCOMING_REVIEW_ROLES.COACH : UPCOMING_REVIEW_ROLES.PARTICIPANT,
                          undefined,
                          1,
                          review.id
                        )
                      ),
                    1000
                  )}>
                  {livecoachLabel}
                </Button>
              )}
              {callsAllowed && (
                <Button
                  variant="outlined"
                  fullWidth
                  className="ev-button"
                  onClick={throttle(() => {
                    CoachingPlaylistActions.setAddCallsMode({
                      planId: plan.id,
                      recipient: plan.recipient.info,
                    });
                    navigateToCallsTab();
                  }, 1000)}>
                  {addLabel}
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }
}
